import React, { useState } from "react";
import "./Login.css";
import { Icon } from "@iconify/react";
import Logo from "assets/Logo.png";
import { Formik } from "formik";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Background from "../Background";

export default function Login() {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // States for checking the errors
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  // Handling the email change
  const handleEmail = (e) => {
    setEmail(e.target.value);
    setSubmitted(false);
  };
  // Handling the password change
  const handlePassword = (e) => {
    setPassword(e.target.value);
    setSubmitted(false);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    // e.preventDefault();
    setSubmitting(true);
    const token = {
      email: values.email,
      password: values.password,
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(token),
    };
    const response = await fetch(
      `${BASE_URL}/auth/clientlogin`,
      requestOptions
    );
    const data = await response.json();
    sessionStorage.setItem("token", JSON.stringify(data));
    // console.log(data);
    // console.log(data.data.token);
    // otpconfirm
    // const tokenCheck = JSON.parse(sessionStorage.getItem("token"));
    // if (tokenCheck === null || tokenCheck.success === false) {
    //   history.push("/");
    // } else {
    //   if (tokenCheck.data.email_verified === false) {
    //      console.log(tokenCheck.data.email_verified);
    //     history.push("/otpconfirm");
    //   } else {
    //     history.push("/dashboard");
    //   }
    // }
    if (data.success === true) {
      window.location = "/dashboard";
    } else {
      alert("Invalid Email Or Password");
    }

    if (email === "" || password === "") {
      setError(true);
    } else {
      setSubmitted(true);
      setError(false);
    }
    setSubmitting(false);
  };
  const togglePassword = (e) => {
    if (showPassword) {
      setShowPassword(false);
    } else {
      setShowPassword(true);
    }
  };

  return (
    <div className="m-auto">
      <Background />
      <div className="main-login-page lay-out">
        <div className="top-logo">
          <a href="/" target="_blank ">
            <img src={Logo} alt="opsways" />
          </a>
        </div>
        <Formik
          initialValues={{ email: "", password: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.email) {
              errors.email = "Required";
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = "Invalid email address";
            }
            if (!values.password) {
              errors.password = "Required";
            }

            return errors;
          }}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <div className="formCenter">
              <form className="formFields" onSubmit={handleSubmit}>
                <div className="formField flex-column d-flex justify-content-start">
                  <label className="formFieldLabel " htmlFor="email">
                    E-Mail Address
                  </label>

                  <input
                    type="email"
                    name="email"
                    //   onChange={handleChange}
                    onBlur={handleBlur}
                    // value={values.email}
                    className="formFieldInput"
                    placeholder="Enter your email"
                    value={email}
                    //   onChange={handleEmail}
                    onChange={(e) => {
                      handleChange(e);
                      handleEmail(e);
                    }}
                  />
                  {errors.email && touched.email && (
                    <div className="errorMessage">{errors.email}</div>
                  )}
                </div>

                <div className="formField">
                  <label className="formFieldLabel" htmlFor="password">
                    Password
                  </label>

                  <div className="d-inline-flex password-input-width  ">
                    <input
                      // onChange={handlePassword}
                      onChange={(e) => {
                        handleChange(e);
                        handlePassword(e);
                      }}
                      value={password}
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="formFieldInput  "
                      //    onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter your Password"
                      //  value={values.password}
                    />

                    <button
                      type="button"
                      className="btn btn-primary btn-sm password-eye-btn"
                      onClick={(e) => togglePassword(e)}
                    >
                      <Icon
                        className="icon-button"
                        icon="typcn:eye"
                        color="black"
                        onClick={(e) => togglePassword(e)}
                      />
                    </button>
                  </div>
                  <div>
                    {errors.password && touched.password && (
                      <div className="errorMessage">{errors.password}</div>
                    )}
                  </div>

                  <div className="mt-1 d-flex justify-content-end">
                    {/* <a
                      href="/generateotp"
                      target="_blank"
                      className="forget-password-link "
                    >
                      Forget password?{" "}
                    </a> */}
                    <Link to="/generateotp" className="forget-password-link ">
                      Forget password?
                    </Link>
                  </div>
                </div>
                <div class="d-flex flex-column mb-3">
                  <button
                    className="formFieldButton login-btn-form  login-btn-css"
                    disabled={isSubmitting}
                  >
                    Sign In
                  </button>{" "}
                  <a
                    href="/"
                    target="_blank"
                    className="formFieldButton login-btn-form login-btn-css text-center "
                    rel="noopener noreferrer"
                  >
                    Create an account
                  </a>
                </div>
              </form>
            </div>
          )}
        </Formik>
      </div>
      {/* <div className="footer-login">
        <a href="https://react.opsways.com/" target="_blank ">
          <img src={Logo} alt="opsways" className="footoer-logo" />
        </a>
      </div> */}
    </div>
  );
}
